import { FC, ReactNode } from 'react';

import { Stack, cn } from '@eluve/components';

type ChipProps = {
  children: ReactNode;
  className?: string;
};

export const Chip: FC<ChipProps> = ({ children, className }) => (
  <Stack
    direction="horizontal"
    fullWidth={false}
    align="center"
    gap={1}
    className={cn(
      'rounded-lg border border-border-primary px-3 py-2',
      className,
    )}
  >
    {children}
  </Stack>
);
